angular.module('b2bLoginApp.services').factory('NotificationFeedbackInterceptor', ["$q", "Notification", "TranslationService", function ($q, Notification, TranslationService) {
    var loginExpired = false;

    return {
        response: function (response) {
            if (typeof response.data === 'object' && typeof response.data.__feedback !== 'undefined') {
                $.each(response.data.__feedback, function(key, item) {
                    switch (item.type) {
                        case 'error':
                            Notification.error(null, item.text);
                            break;
                        case 'success':
                            Notification.success(null, item.text);
                            break;
                        case 'message':
                        default:
                            Notification.message(null, item.text);
                            break;
                    }
                });
                delete response.data.__feedback;
            }
            return $q.when(response);
        },
        responseError: function (response) {
            if (response.status === 403) {
                Notification.message(null, TranslationService.trans('overview.logged_out_inactivity'));
                loginExpired = true;
                return $q.reject(response);
            }

            var notificationMessage = TranslationService.trans('overview.leads.error');

            Notification.error(null, notificationMessage);
            return $q.reject(response);
        },
        loginExpired: function() { return loginExpired; }
    };
}]);
